import { format } from 'date-fns';
import {
  Page,
  Text,
  View,
  Font,
  Document,
  Image
} from '@react-pdf/renderer';

import { columnsNested } from 'utils/columns-table';
import { capitalize } from 'utils';
import { useNormalizeNestedCell as normalizeNestedCell } from '../grid-table/use-normalize-cell';

// @ts-ignore
import FontPoppinsRegular from 'assets/fonts/Poppins-Regular.ttf';
// @ts-ignore
import FontPoppinsBold from 'assets/fonts/Poppins-Bold.ttf';
// @ts-ignore
import FontPoppinsMedium from 'assets/fonts/Poppins-Medium.ttf';

Font.register({
  family: 'Poppins',
  fonts: [
    {
      src: FontPoppinsRegular
    },
    {
      src: FontPoppinsMedium,
      fontWeight: 500
    },
    {
      src: FontPoppinsBold,
      fontWeight: 'bold'
    }
  ]
});

// @ts-ignore
import logo from 'assets/images/logo.png';
// @ts-ignore
import wallet from 'assets/images/wallet.png';
import styles from './styles';

const TableHead = () => {
  return (
    <View style={styles.head}>
      {['Project', 'Country', 'Project Activity', 'Amount'].map((item) => (
        <Text key={`TableHead-${item}`} style={styles.headcell}>{item}</Text>
      ))}
    </View>
  );
};

const TableRow = ({ item }) => {
  return (
    <View style={styles.body}>
      {columnsNested.map(({ dataIndex }) => {
        const { cellValue } = normalizeNestedCell(item, dataIndex, true);
        return <Text key={`TableRow-${dataIndex}`} style={styles.cell}>{cellValue}</Text>;
      })}
    </View>
  );
};

const TableBody = ({ data }) => {
  return data.map((item) => {
    return <TableRow key={item.project_id} item={item} />;
  });
};

const Table = ({ data }) => {
  return (
    <View style={styles.table}>
      <TableHead />
      <TableBody data={data} />
    </View>
  );
};

const Footer = ({ accountId }) => {
  return (
    <View style={styles.footer}>
      <Text
        style={styles.pagination}
        render={({ pageNumber }) => `Page ${pageNumber}`}
        fixed
      />
      <View style={styles.textline}>
        <Image style={styles.icon} src={wallet} />
        <Text>
          Retire Wallet Address: <Text style={styles.link}>{accountId}</Text>
        </Text>
      </View>
    </View>
  );
};

const CertificatePDF = ({ data, title, accountId, amount }) => {
  return (
    <Document>
      <Page size="A4" wrap style={styles.page}>
        <Image style={styles.logo} src={logo} />
        <View style={styles.section}>
          <Text style={styles.title}>Through Open Forest Protocol</Text>
          <Text style={styles.subtitle}>
            {`${capitalize(
              title
            )} has retired ${amount} of Open Carbon Credits or
            tonnes of CO2e on ${format(new Date(), 'dd.MM.yyyy')}.`}
          </Text>
          <Text style={styles.subtitle}>
            The Retirement Consists of the Following Projects:
          </Text>
        </View>
        <Table data={data} />
        <Footer accountId={accountId} />
      </Page>
    </Document>
  );
};

export default CertificatePDF;
